import type { PapelUsuario } from '@pgcustom/shared-types';

export interface PermissoesRelatorios {
  ler: boolean;
}

/**
 * Espelho, no frontend, do grant real de RBAC do recurso `relatorios`
 * (`apps/api/src/modules/relatorios/relatorios.routes.ts`, migrations
 * `019`/`036`): `admin` (curinga `*`), `financeiro` (`ler` — `PRODUCT.md`
 * 4.2 cita "previsão de caixa" como parte do módulo Financeiro) e
 * `marketing` (`ler`, migration 036 — fecha o gap encontrado na
 * auditoria de integração: o dashboard do Colaborador precisa do
 * faturamento/pedidos pagos do site, a própria base da comissão dele).
 * Nenhum outro papel foi seedado.
 */
export function permissoesRelatorios(papel: PapelUsuario): PermissoesRelatorios {
  if (papel === 'admin' || papel === 'financeiro' || papel === 'marketing') return { ler: true };
  return { ler: false };
}
